module.exports = __webpack_public_path__ + "img/secondary_6x4_z18.09a570df.svg";